var _circle, _circle2, _circle3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.66
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6953,
    cy: 60.4023,
    r: 60,
    fill: "url(#paint0_radial_1209_34114)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 60.6953,
    cy: 60.4023,
    r: 32,
    fill: "#7551FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 60.6953,
    cy: 60.4023,
    r: 35.6048,
    stroke: "#7551FF",
    strokeWidth: 0.790345
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2864 47.9218C66.8071 47.4011 67.6513 47.4011 68.172 47.9218L73.5053 53.2551C74.026 53.7758 74.026 54.62 73.5053 55.1407L56.172 72.4741C55.9219 72.7241 55.5828 72.8646 55.2292 72.8646H49.8958C49.1595 72.8646 48.5625 72.2676 48.5625 71.5312V66.1979C48.5625 65.8443 48.703 65.5052 48.953 65.2551L62.2861 51.9221L66.2864 47.9218ZM63.2292 54.7502L51.2292 66.7502V70.1979H54.6769L66.6769 58.1979L63.2292 54.7502ZM68.5625 56.3123L70.6769 54.1979L67.2292 50.7502L65.1148 52.8646L68.5625 56.3123Z",
    fill: "#7551FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1209_34114",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6953 60.4023) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080015",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPen);
export default __webpack_public_path__ + "static/media/TeamPen.bc86fa1ecdb1314cf8cf6a83a85c4aba.svg";
export { ForwardRef as ReactComponent };